import { render } from "./DashboardNpsTrends.vue?vue&type=template&id=53ff1e02"
import script from "./DashboardNpsTrends.vue?vue&type=script&lang=js"
export * from "./DashboardNpsTrends.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__